module.exports = __webpack_public_path__ + "static/img/01.bde26ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/01.png
// module id = fYCA
// module chunks = 2